import React, { Component } from 'react';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import styles from './styles.sass';

// redux form to bootstrap dropdown button glue
class StyledSelectDropdown extends Component {
  render() {
    const {
      className,
      children,
      id,
      input,
      meta: { error, touched },
      onChange,
      renderTitle,
    } = this.props;
    const value = input.value;
    return (
      <div className={className || styles.dropdown}>
        <Dropdown
          id={id}
          onSelect={e => {
            input.onChange(e);
            onChange && onChange(e);
          }}
        >
          <Dropdown.Toggle>
            {renderTitle ? renderTitle(value) : value}
            <span />
          </Dropdown.Toggle>
          <Dropdown.Menu>{children}</Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

export default StyledSelectDropdown;
